export const downloadAsset = (fileName, asset) => {
  const link = document.createElement('a');
  link.download = fileName;
  link.href = asset;
  link.click();
};
